import { contactInfo, eventTypes } from "../../data/content";
import useFormSubmit from "../../hooks/useFormSubmit";
import useReveal from "../../hooks/useReveal";
import { Field, SelectField, TextareaField } from "../ui/Field";
import FormStatus from "../ui/FormStatus";
import SectionTitle from "../ui/SectionTitle";
import SocialIcons from "../ui/SocialIcons";

export default function Reservation() {
  const { status, errors, submit } = useFormSubmit();
  const formRef = useReveal();

  const handleSubmit = (e) => {
    e.preventDefault();
    submit(e.target);
  };

  return (
    <section id="reservation" className="scroll-mt-20 bg-ink py-20 sm:py-28">
      <div className="container grid gap-14 lg:grid-cols-2">
        <div>
          <SectionTitle eyebrow="Réservation" title="Formulaire de réservation d’une prestation" />
          <p className="mb-8 text-lg text-stone-200">
            Décrivez votre projet (mariage, festival, soirée privée, atelier…) et nous vous répondrons
            rapidement par email ou téléphone pour finaliser les détails.
          </p>

          <dl className="divide-y divide-white/10 rounded-2xl bg-surface">
            <div className="flex flex-wrap items-center justify-between gap-2 px-6 py-4">
              <dt className="text-xs font-semibold uppercase tracking-wide text-stone-400">Téléphone</dt>
              <dd>
                <a href={`tel:${contactInfo.phoneHref}`} className="text-white hover:text-gold-500">
                  {contactInfo.phone}
                </a>
              </dd>
            </div>
            <div className="flex flex-wrap items-center justify-between gap-2 px-6 py-4">
              <dt className="text-xs font-semibold uppercase tracking-wide text-stone-400">E-mail</dt>
              <dd>
                <a href={`mailto:${contactInfo.email}`} className="text-white hover:text-gold-500">
                  {contactInfo.email}
                </a>
              </dd>
            </div>
            <div className="flex flex-wrap items-center justify-between gap-2 px-6 py-4">
              <dt className="text-xs font-semibold uppercase tracking-wide text-stone-400">Localisation</dt>
              <dd className="text-right text-white">{contactInfo.locationLong}</dd>
            </div>
            <div className="flex flex-wrap items-center justify-between gap-2 px-6 py-4">
              <dt className="text-xs font-semibold uppercase tracking-wide text-stone-400">Suivez-nous</dt>
              <dd>
                <SocialIcons />
              </dd>
            </div>
          </dl>
        </div>

        <div ref={formRef} className="reveal">
          <FormStatus
            status={status}
            errors={errors}
            successMessage="Votre demande de réservation a bien été envoyée, nous vous répondrons dans les plus brefs délais."
          />
          <form onSubmit={handleSubmit} noValidate>
            <input type="hidden" name="form_type" value="reservation" />
            <div className="grid gap-4 sm:grid-cols-2">
              <Field id="res-nom" name="name" label="Nom complet" required />
              <Field id="res-email" name="email" type="email" label="Email" required />
              <Field id="res-phone" name="phone" type="tel" label="Téléphone" />
              <Field id="res-date" name="date" type="date" label="Date de l’événement" required />
              <Field id="res-heure" name="heure" type="time" label="Heure de début" required />
              <Field id="res-duree" name="duree" label="Durée souhaitée (ex : 1h30)" />
              <Field id="res-lieu" name="lieu" label="Lieu (ville / adresse)" className="sm:col-span-2" />
              <SelectField
                id="res-type"
                name="type_event"
                label="Type d’événement"
                options={eventTypes}
                className="sm:col-span-2"
              />
              <TextareaField
                id="res-message"
                name="message"
                label="Message / détails supplémentaires"
                className="sm:col-span-2"
              />
            </div>
            <button type="submit" disabled={status === "submitting"} className="btn-outline mt-6 w-full disabled:opacity-60">
              {status === "submitting" ? "Envoi en cours…" : "Envoyer la demande de réservation"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
